/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-message[_ngcontent-%COMP%]{background-color:#000;text-align:center;color:red;padding:8px}#scanner-container[_ngcontent-%COMP%]{height:300px;position:relative}#scanner-container[_ngcontent-%COMP%]  canvas{visibility:hidden;position:absolute;left:0;top:0}#scanner-container[_ngcontent-%COMP%]  video{width:100%;height:300px;-o-object-fit:cover;object-fit:cover}"];
export { styles as styles };
